// extracted by mini-css-extract-plugin
module.exports = {"colorGood":"#31c110","colorWarn":"#ffa500","colorBad":"#ff0000","bgGood":"#b5f8a5","bgWarn":"#ffedcc","bgBad":"#ffcccc","rangeDisplay":"QualityIndicator_rangeDisplay__1mLsZ"};